import React from 'react'
import Image from 'next/image'

import styled from '@emotion/styled'
import { useTranslation } from 'next-i18next'

import { PromotionLabel } from 'components/ktc/PromotionLabel'
import Space from 'components/common/Space'

const KTCPromotions = ({
  promotions_2,
  rate = false,
  highlight = false,
  styles = null,
}) => {
  const { t } = useTranslation()

  return (
    promotions_2 && (
      <Container style={styles ? styles : {}}>
        {promotions_2.offline.length > 0 && (
          <li className="display-flex">
            <PromotionLabel>{t('ktc:offline_benefit')}</PromotionLabel>
            {promotions_2.offline.map((item, index) => (
              <div key={index} className="display-flex benefits">
                <Image src={item.image} alt="" width={16} height={16} />
                {rate && (
                  <p
                    style={{
                      boxShadow:
                        highlight && item.highlight
                          ? 'inset 0 24px 0 yellow'
                          : 'none',
                    }}
                    className="promotions_rate"
                  >
                    {item.rate}
                  </p>
                )}
                <p className="vertical-line"> | </p>
              </div>
            ))}
          </li>
        )}

        {promotions_2.offline.length > 0 && promotions_2.online.length > 0 && (
          <Space top={8} />
        )}

        {promotions_2.online.length > 0 && (
          <li className="display-flex">
            <PromotionLabel>{t('ktc:online_benefit')}</PromotionLabel>
            {promotions_2.online.map((item, index) => (
              <div key={index} className="display-flex benefits">
                <Image src={item.image} alt="" width={16} height={16} />
                {rate && (
                  <p
                    style={{
                      boxShadow:
                        highlight && item.highlight && 'inset 0 24px 0 yellow',
                    }}
                    className="promotions_rate"
                  >
                    {item.rate}
                  </p>
                )}

                <p className="vertical-line"> | </p>
              </div>
            ))}
          </li>
        )}
      </Container>
    )
  )
}

export default KTCPromotions

const Container = styled.ul`
  padding: 10px;

  img {
    margin-right: 4px;
  }

  .display-flex {
    display: flex;
    align-items: center;
  }

  .promotions_rate {
    font-size: 12px;
    font-weight: 700;
  }

  .vertical-line {
    padding-left: 4px;
    margin-right: 4px;
  }

  .benefits:last-child .vertical-line {
    display: none;
  }
`
